import { useQuery } from "@tanstack/react-query";

import { Spinner } from "@/components/Spinner";
import { Avatar } from "@/components/ui/avatar";
import { getHydratedPostQueryOptions } from "@/lib/api";

export function CampaignPostPreview({ uri }: { uri: string }) {
  const { data: post, isPending } = useQuery(getHydratedPostQueryOptions(uri));

  if (isPending || !post) {
    return <Spinner />;
  }

  return (
    <div className="flex gap-4 items-center overflow-hidden">
      <Avatar size="sm" src={post.author.avatar} alt={post.author.handle} />
      <div className="flex flex-col gap-1">
        <div className="text-xs text-slate-dim">@{post.author.handle}</div>
        <div className="line-clamp-2 whitespace-pre-wrap">
          {post.record.text}
        </div>
      </div>
    </div>
  );
}
